import { Platform, type ViewStyle } from 'react-native';

/** Apply last so iOS glass decoration cannot leak into an Android fallback. */
export function getAndroidFlatSurfaceStyle(backgroundColor: string): ViewStyle | undefined {
  if (Platform.OS !== 'android') return undefined;

  return {
    backgroundColor,
    borderWidth: 0,
    shadowOpacity: 0,
    shadowRadius: 0,
    elevation: 0,
    boxShadow: [],
  };
}
